import { Route } from "react-router-dom";
import SignUp from "../infrastructure/react/components/SignUp";
import Chats from '../infrastructure/react/containers/chats'
import AuthUserContainer from "../infrastructure/react/containers/AuthUserContainer";


const commonRoutes = (
  <>
    <Route path="/" element={<AuthUserContainer />} />
  </>
);

export default commonRoutes;